import { defineMessages } from 'react-intl'

export default defineMessages({
  closeUpTitle: {
    id: 'app.blog.closeUpTitle',
    defaultMessage: 'Close-Up',
  },
  closeUpTagLine: {
    id: 'app.blog.closeUpTagLine',
    defaultMessage:
      'An interactive, constantly evolving magazine dedicated to the world of Independent Film',
  },
  nowShowingStatus: {
    id: 'app.blog.nowShowingStatus',
    defaultMessage: 'is now showing on Flix Premiere',
  },
  filmsHeading: {
    id: 'app.blog.filmsHeading',
    defaultMessage: 'Featured Film',
  },
  pressTitle: {
    id: 'app.blog.pressTitle',
    defaultMessage: 'Press Room',
  },
  pressTagLine: {
    id: 'app.blog.pressTagLine',
    defaultMessage:
      'All the latest news from the home of the best Indie movies from top film festivals across the world',
  },
  festivalTitle: {
    id: 'app.blog.blogTitle',
    defaultMessage: 'Festival News',
  },
  readMore: {
    id: 'app.blog.readMore',
    defaultMessage: 'Read More',
  },
  shareArticle: {
    id: 'app.blog.shareArticle',
    defaultMessage: 'Share this article:',
  },
  linkCopied: {
    id: 'app.blog.linkCopied',
    defaultMessage: 'Successfully copied link!',
  },
  otherArticlesTitle: {
    id: 'app.blog.otherArticlesTitle',
    defaultMessage: 'More from Flix Premiere',
  },
})
